import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-solid-icon',
  templateUrl: './files-folder-solid.component.html'
})
export class FilesFolderSolidComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
